
<nb-card style="width: 60%; margin: 0 auto;">
    <nb-card-header>{{"COMPARING_HEADING" | translate }}</nb-card-header>
    <nb-card-body innerHTML='{{"COMPARING_CONTENT" | translate}}'></nb-card-body>
    <nb-card-footer><button nbButton (click)="close()">{{"CLOSE" | translate}}</button></nb-card-footer>
</nb-card>